import type { UserProfile } from "@hobbyshopify/backend-client";
import { ChangeNotifier } from "subtree.js/core";

/**
 * `failed` is not `signedOut`: Firebase holds a valid session but `/user/me`
 * did not answer. Sending that user to the login form would loop, since signing
 * in again succeeds at Firebase and changes nothing here.
 */
export type ProfileStatus =
  | { readonly kind: "idle" }
  | { readonly kind: "loading" }
  | { readonly kind: "loaded"; readonly profile: UserProfile }
  | { readonly kind: "failed"; readonly message: string };

export class ProfileRepository extends ChangeNotifier {
  #status: ProfileStatus = { kind: "idle" };

  get status(): ProfileStatus {
    return this.#status;
  }

  get profile(): UserProfile | null {
    return this.#status.kind === "loaded" ? this.#status.profile : null;
  }

  set(status: ProfileStatus): void {
    this.#status = status;
    this.notifyListeners();
  }

  reset(): void {
    if (this.#status.kind !== "idle") this.set({ kind: "idle" });
  }
}
